//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DropMenus from './DropMenus.vue';
export default {
    components: { DropMenus },
    data() {
        return {
            menus: []
        };
    },
    computed: {
        active() {
            return this.$route.name;
        }
    },
    created() {
        this.getMenus();
    },
    methods: {
        setLocal(val) {
            this.$store.dispatch('setLanguage', val.name);
        },
        getMenus() {
            this.axios({
                url: 'articleCategory/listTree',
                data: {
                    pid: 0
                }
            }).then((res) => {
                if (res) {
                    this.menus = res.data;
                    this.$emit('loaded', this.menus);
                }
            });
        },
        tryTo(location, anchor) {
            if (location === this.$route.name) {
                this.$router.push({
                    name: location,
                    query: {
                        anchor
                    }
                });
            } else {
                this.$router.push({
                    name: location,
                    params: {
                        anchor
                    }
                });
            }
        }
    }
};
